package com.karyadina.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
actual fun rememberDocumentScannerLauncher(
    onResult: (String?) -> Unit
): DocumentScannerLauncher {
    return remember {
        object : DocumentScannerLauncher {
            override fun launch() {
                // Not supported on web
                onResult(null)
            }
        }
    }
}
